import React, { Component } from 'react';
import { Divider, HTMLTable, Tag, Intent } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Agents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agents: [
        { name: 'Agent Server #1 (World Main)', ip: '127.0.0.1', port: 15882, players: 1482, load: '4.8%', status: 'ONLINE' },
        { name: 'Agent Server #2 (Battle Arena)', ip: '127.0.0.1', port: 15883, players: 320, load: '1.9%', status: 'ONLINE' },
      ]
    };
  }

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          Agent Servers & Player Session Nodes
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Monitor Agent Server instances, active player capacity, and memory allocation.
        </p>

        <Divider className="mb-4" />

        <HTMLTable bordered condensed striped style={{ width: '100%', fontSize: '0.82rem' }}>
          <thead>
            <tr>
              <th style={{ color: '#182026' }}>Agent Server Name</th>
              <th style={{ color: '#182026' }}>Listen Port</th>
              <th style={{ color: '#182026' }}>Active Session Players</th>
              <th style={{ color: '#182026' }}>CPU Load</th>
              <th style={{ color: '#182026' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {this.state.agents.map((a, i) => (
              <tr key={i}>
                <td className="font-weight-bold" style={{ color: '#182026' }}>{a.name}</td>
                <td className="font-mono text-warning font-weight-bold">{a.port}</td>
                <td className="font-weight-bold" style={{ color: '#106ba3' }}>{a.players} Players</td>
                <td className="font-mono text-success">{a.load}</td>
                <td><Tag intent={Intent.SUCCESS} round>{a.status}</Tag></td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
      </SideMenuWrapper>
    );
  }
}
